"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
var _progressModule = _interopRequireDefault(require("./progress.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ArcProgress(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_progressModule["default"].pagination)
  }, /*#__PURE__*/_react["default"].createElement(_lib.Progress, {
    format: props.format,
    percent: props.percent,
    showInfo: props.showInfo,
    size: props.size,
    status: props.status,
    strokeColor: props.strokeColor,
    strokeLinecap: props.strokeLinecap,
    type: props.type,
    success: props.success,
    steps: props.steps,
    strokeWidth: props.strokeWidth,
    width: props.width,
    gapDegree: props.gapDegree,
    gapPosition: props.gapPosition
  }));
}
var _default = ArcProgress;
exports["default"] = _default;